import {
    AddressLookupResult,
    cityFromLookup,
    provinceCodeFromLookup,
    streetFromLookup
} from "../services/address-lookup/address-lookup.service";

export interface Province {
    id: string;
    name: string;
}

let provincesRequest: Promise<Province[]> | null = null;

/** Elenco delle province italiane (sigla + nome), caricato una sola volta da `assets/italia_comuni.json`. */
export function loadItalianProvinces(): Promise<Province[]> {
    if (!provincesRequest) {
        provincesRequest = fetch('assets/italia_comuni.json')
            .then(response => response.json())
            .then((res: any) => {
                const provinces: Province[] = [];
                res.regioni.forEach((region: any) =>
                    region.province.forEach((province: any) => provinces.push({id: province.code, name: province.nome})));
                return provinces.sort((a, b) => a.name.localeCompare(b.name, 'it'));
            })
            .catch(error => {
                console.error('error fetching locationData: ', error);
                provincesRequest = null;
                return [];
            });
    }
    return provincesRequest;
}

/** Indirizzo (via + civico), città e sigla provincia ricavati da un suggerimento di ricerca indirizzo. */
export function residenceFromLookup(result: AddressLookupResult, provinces: Province[]): { address: string; city?: string; province?: string } {
    return {
        address: [streetFromLookup(result), result.address?.house_number].filter(Boolean).join(' '),
        city: cityFromLookup(result),
        province: provinceCodeFromLookup(result, provinces),
    };
}
